module.exports = __webpack_public_path__ + "img/small-word-01.c82e052d.png";